import { json } from 'react-router-dom';

const NotFound = () => {
  throw json(null, { status: 404, statusText: 'Not found' });
};

export default NotFound;
